<template>
  <div class="bg">
    <div style="height: 60%;">
      <img src="../../static/image/sharebj1.png" class="sharet" />
    </div>
    <div class="xzdd">
      <div class="addd" @click="androdios">
        <img src="../../static/image/android.png" class="android" />
        <div class="andrxz">立即下载</div>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: "share",
    data() {
      return {

      }
    },
    components: {

    },
    methods: {
      androdios() {
        var u = navigator.userAgent;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //Android
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //iOS
        if (isAndroid)
          this.androdd()
        else
          this.ios()
      },
      androdd() {
        window.location.href = "http://hotel.szphdl.com/apks/hotel.apk"
      },
      ios() {
        window.location.href = "https://apps.apple.com/cn/app/%E6%99%AE%E5%8D%8E%E7%BB%B4%E4%BF%9D/id1545505506"
      }
    }
  }
</script>

<style scoped>
  .xzdd {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    height: 184px;
  }

  .andrxz {
    font-size: 20px;
    color: #ffffff;
    float: left;
  }

  .iphoxiz {
    font-size: 20px;
    color: #ffffff;
    float: left;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ios {
    width: 36px;
    float: left;
  }

  .android {
    width: 36px;
    float: left;
  }

  .isdd {
    background-color: #4e58f7;
    padding: 4px;
    height: 38px;
    width: 188px;
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .addd {
    background-color: #4e58f7;
    border-radius: 50px;
    height: 48px;
    width: 196px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    display: flex;
    margin: 30px 0px 0px 0px;
  }

  .bg {}

  .sharet {
    width: 100%;
    height: 460px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/share.vue